import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../../StateContext/Application";
import { Form, Link, redirect, useNavigate } from "react-router-dom";
import apiurl from "../../../../../path";
const AuctionWinnerDeclartion = () => {
  const data = useContext(AdminContext);
  const { AuctionWinnerDeclartionGet } = data;
  const [renderdata, SetRenderdata] = useState([]);
  const Navigate = useNavigate();
  useEffect(() => {
    try {
      async function getlist() {
        let d = await AuctionWinnerDeclartionGet();
        SetRenderdata(d);
      }
      getlist();
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <>
      <div style={{ backgroundColor: "#f6f8fc", padding: "50px" }}>
        <div
          style={{
            display: "grid",
            border: "2px solid red",
            borderRadius: "20px",
            border: "none",
            padding: "20px",
            backgroundColor: "white",
          }}
        >
          <div className="mb-3 mx-3">
            <h5>Tender Winner Declare </h5>
          </div>
          <div className=" mb-3 mx-3">
            <select
              onChangeCapture={(e) => {
                return Navigate(e.currentTarget.value);
              }}
              className="form-control"
            >
              <option>Select Tender</option>
              {renderdata &&
                renderdata?.map((e) => (
                  <option
                    style={{ border: "1px solid red" }}
                    value={
                      "/AdminDashboard/WinnerDeclartionForm/" + e.Tender_ID
                    }
                  >
                    <button className="btn btn-dark">{e.Tender_Name}</button>
                  </option>
                ))}
            </select>
          </div>
        </div>
        
      </div>
    </>
  );
};

export default AuctionWinnerDeclartion;
